import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

// 9 Oct 2026: guides no longer recommend a stack. A stack shown next to a
// guide for a given decade reads as "this product for these symptoms", which
// is a health claim; the sidebar now carries a plain link to the shop only.
export default function GuideLayout({ meta, hero, content, relevantTests }) {
  return (
    <>
      <Helmet defer={false}>
        <title>{meta.title} | Hormonely</title>
        <meta name="description" content={meta.description} />
      </Helmet>

      <div className="guide-page">
        <div className="guide-hero">
          <div className="container guide-hero__inner">
            <div className="eyebrow guide-hero__eyebrow">{hero.eyebrow}</div>
            <h1 className="guide-hero__title">{hero.title}</h1>
            <p className="guide-hero__intro">{hero.intro}</p>
            <div className="guide-hero__actions">
              <a href={relevantTests[0]?.url} target="_blank" rel="noopener noreferrer" className="btn-clay">
                Book a blood test
              </a>
            </div>
          </div>
        </div>

        <div className="guide-content">
          <div className="container">
            <div className="guide-layout">
              <div className="guide-body">
                <div className="disclaimer-box">
                  This page provides information only. It is not medical advice. Always speak to your GP or a qualified health professional before making changes to your health, starting supplements, or pursuing hormone treatment.
                </div>
                {content}
              </div>

              <aside className="guide-sidebar">
                <div className="sidebar-card">
                  <div className="sidebar-card__title">Home blood tests</div>
                  {relevantTests.map((t, i) => (
                    <a key={i} href={t.url} target="_blank" rel="noopener noreferrer" className="sidebar-test">
                      <div>
                        <div className="sidebar-test__name">{t.name}</div>
                        <div style={{ fontSize: '11px', color: 'var(--stone)', marginTop: '2px' }}>{t.desc}</div>
                      </div>
                      <div className="sidebar-test__price">{t.price}</div>
                    </a>
                  ))}
                  <p className="sidebar-affiliate">Hormonely readers receive 10% off all Medichecks panels. Home finger-prick test. Results in 48 hours. Your GP can tell you whether a test is right for you.</p>
                </div>

                <div className="sidebar-card">
                  <div className="sidebar-card__title">Stacks by Hormonely</div>
                  <div style={{ fontSize: '13px', color: 'var(--stone)', lineHeight: 1.5, marginBottom: '12px' }}>Food supplements made in the UK under GMP standards. Food supplements should not replace a varied diet.</div>
                  <Link to="/stacks" className="btn-clay" style={{ display: 'block', textAlign: 'center', fontSize: '13px', padding: '11px' }}>
                    Browse the shop
                  </Link>
                </div>

                <div className="sidebar-card">
                  <div className="sidebar-card__title">Free symptom checklist</div>
                  <p style={{ fontSize: '13px', color: 'var(--stone)', lineHeight: 1.5, marginBottom: '14px' }}>Download the Hormonely symptom checklist to take to your GP.</p>
                  <Link to="/#email" className="btn-primary" style={{ display: 'block', textAlign: 'center', fontSize: '13px', padding: '11px' }}>
                    Get the checklist
                  </Link>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
